import { DependencyList, useEffect } from 'react'
import { useConfigurationStore } from '@stores'

const useLoadAtlasesWhenGameSettingsReady = (
    getAtlasPaths: () => string[],
    loadAtlasesFromPath: (atlasPaths: string[]) => Promise<void>,
    dependencies: DependencyList = []
) => {
    const isGameLoaded = useConfigurationStore((state) => state.isGameLoaded)

    useEffect(() => {
        if (!isGameLoaded) {
            return
        }

        const atlasPaths = getAtlasPaths()

        if (atlasPaths.length === 0) {
            return
        }

        loadAtlasesFromPath(atlasPaths)
    }, [isGameLoaded, loadAtlasesFromPath, ...dependencies])
}

export default useLoadAtlasesWhenGameSettingsReady
